import React ,{useState,useRef} from 'react';
import { Link } from 'react-router-dom';
import { Col, Row} from 'react-bootstrap';
import Logo from './../assets/icons/logo2.jpeg';
import LoginNav from './LoginNav';
import image1 from './../assets/web_imgs/ET-img-1.jpeg'
import image2 from './../assets/web_imgs/ET-image-2.jpg'
import image3 from './../assets/web_imgs/ET-img-3.jpg'
import image4 from './../assets/web_imgs/ET-img-4.jpg'
import image5 from './../assets/web_imgs/ET-img-5.png'
import image6 from './../assets/web_imgs/company-img-1_v2.png'
import image7 from './../assets/web_imgs/company-img-2.jpeg'
import image8 from './../assets/web_imgs/company-img-3.jpg'
import image9 from './../assets/web_imgs/company-img-4.jpeg'
import image10 from './../assets/web_imgs/company-img-5.png'
import image11 from './../assets/web_imgs/company-img-6.png'
// import './EngageTalent.css'; // Import the corresponding CSS file
import { useInView } from 'react-intersection-observer';
import { postDataLogin } from '../ApiServices/ApiService';

const HomePage = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: '',
      });
      const [success, setSuccess] = useState('');
      const [loader, setLoading] = useState(false);
    
      const handleChange = (e) => {
        setFormData({
          ...formData,
          [e.target.name]: e.target.value,
        });
      };
    
      const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess('')
        console.log('formData:',formData)
    
        const payload = {
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message
        }
        setLoading(true);
        try {
          await postDataLogin('/website/contact-us',payload).then(resp => {            
          setLoading(false);
            if(resp.statusCode === 200){
              if(resp.message.toLowerCase() === 'success'){
                setSuccess(resp.info)
              }else{
                setSuccess(resp.info); 
                setLoading(false);
              }
           
            }else if(resp.statusCode === 500){
              setLoading(false);
                setSuccess(resp.info);        
            }else{
              setLoading(false);
              setSuccess('Network Error');
            }
          }).catch((error) => {
            setLoading(false);
            setSuccess(' Network Error');
            console.log('network error:', error);
          });
        } catch (error) {
          setLoading(false);
          // Handle login error, e.g., display an error message to the user.
          console.error('Login failed', error);
        }
      };
      const contactDetailStyle = {
        color: '#2b7a78',
        fontSize: '1.5rem',
      };
    
      const contactInfoStyle = {
        fontSize: '1.2rem',
        color: '#555',
      };

      const [ref, inView] = useInView({
        triggerOnce: true,
      });
    
      const animateClassLeft = inView ? 'animate' : 'animate-left';
      const animateClassRight = inView ? 'animate-left' : 'animate';

  return (
    <div>
      <div className="nav-bar-fixed">
      <LoginNav></LoginNav>
      </div>
      <header className="neader-div">
        <div className='row' style={{width:'100%'}}>
      
          <div className='col-md-8 grid-sty'>
            <div className={`  ${animateClassLeft}`} ref={ref}>
            <img src={Logo} className='header-logos'/>
        <h1 style={{fontSize:20}}>Welcome to EngageTalent.AI</h1>
        <p style={{color:'white'}}>Streamline your hiring process with the power of AI.</p>
            </div>

          </div>
          <div className='col-md-4'>
          <img src={image1} className={`web-imgs-1  ${animateClassRight}`} ref={ref}/>
          </div>
      
   
        </div>
      </header>

      <section id="introduction" className={`introduction-section `} >
      <div className="container">
      <div className="row row-col-rev">
      <div className='col-md-4 mx-auto '>
          <div className='img-div'>
        <img src={image3} className={`web-imgs-3 ${animateClassLeft}`} ref={ref}/>

          </div>
        </div>
        <div className="col-md-8 mx-auto text-center ">
          <h2 className="section-heading header-title" style={{ fontWeight: 700, fontSize: '2rem', margin: 0 }}>
            Introducing EngageTalent.AI
          </h2>
          <hr className="my-4" style={{ borderTop: '3px solid #5e5e5e', width: '80%' }} />
          <p className={`text-muted mb-4 text-justify  ${animateClassLeft}`} ref={ref} style={{ fontSize: '1.2rem', lineHeight: 1.6, color: '#555' }}>
            In the fast-paced world of talent acquisition, EngageTalent.AI by Data Lake Solutions LLC stands as a beacon of innovation,
            offering recruiting firms an unprecedented AI-powered platform to evaluate candidates with precision and speed. We understand
            the intricacies of the hiring process and the demand for quality talent that drives the success of every enterprise. Our technology
            is not just about automating interviews; it's about enhancing human decision-making with deeper insights and analytics.
          </p>
          <p className={`text-muted mb-4 text-justify  ${animateClassRight}`} ref={ref} style={{ fontSize: '1.2rem', lineHeight: 1.6, color: '#555' }}>
            EngageTalent.AI leverages advanced Large Language Models (LLMs) to pose challenging technical problems, assess coding skills, and
            provide a detailed grading rubric that mirrors the keenest technical interviewers. Our platform generates comprehensive summary
            reports that capture the essence of each candidate's potential, enabling recruiters to present hiring managers with a clear and
            concise evaluation. This isn’t just a tool; it’s your technology partner in the journey to discover and onboard the finest
            professionals efficiently.
          </p>
          <p className={`text-muted mb-4 text-justify ${animateClassLeft}`} ref={ref} style={{ fontSize: '1.2rem', lineHeight: 1.6, color: '#555' }}>
            The synergy of AI and human expertise in EngageTalent.AI ensures a recruitment experience that is as reliable as it is revolutionary.
            Embrace the future of hiring with a platform that not only saves time but also secures the best fit for every role. Join us at the
            forefront of the recruitment transformation where EngageTalent.AI is not just changing how teams are built, but also how the very
            foundation of recruitment is perceived.
          </p>
          {/* <center>
            <button className="button-demo">Demo</button>
          </center> */}
        </div>
    

      </div>
    </div>
      </section>

      <section id="use-cases" className={`use-cases-section`}>
      <div className="container">
      <div className="row">
   
        <div className="col-lg-8 mx-auto">
          <h2 className="section-heading text-center custom-heading header-title">Use Cases of EngageTalent.AI</h2>
          <hr className="my-4 custom-hr" />
          <div className={`use-case-description custom-use-case  ${animateClassRight}`} ref={ref}>
            <h3 className="custom-subheading sub-header-title">Technical Skill Assessment</h3>
            <p className="custom-paragraph">
              EngageTalent.AI is adept at gauging the depth of a candidate’s technical expertise through a series of adaptive questions tailored to their resume. From fundamental concepts to complex problem-solving abilities in various domains such as software development, data science, and cybersecurity, our AI-driven approach ensures that only the most competent candidates proceed to the next stage of your hiring process.
            </p>
          </div>
          <div className={`use-case-description custom-use-case  ${animateClassLeft}`} ref={ref}>
            <h3 className="custom-subheading sub-header-title">Coding Proficiency Evaluation</h3>
            <p className="custom-paragraph">
              With our sophisticated code analysis tools, EngageTalent.AI evaluates candidates' coding skills in real-time. The platform presents coding challenges that range from writing simple functions to developing algorithms, providing an accurate measure of a candidate's programming capabilities across different languages and frameworks. Our intelligent grading system then offers insightful feedback, highlighting strengths and areas for improvement.
            </p>
          </div>
          <div className={`use-case-description custom-use-case   ${animateClassRight}`} ref={ref}>
            <h3 className="custom-subheading sub-header-title">Automated Summary Reports</h3>
            <p className="custom-paragraph">
              After each assessment, EngageTalent.AI compiles detailed summary reports that provide a holistic view of the candidate's technical prowess. These reports include performance metrics, coding efficiency, and problem-solving skills, along with personalized insights that help recruiters and hiring managers make informed decisions. The reports are designed to be easily interpretable, ensuring that you can quickly identify top talent.
            </p>
            {/* <div className="custom-center">
              <button className="custom-button">Demo</button>
            </div> */}
          </div>
        </div>
        <div className='col-lg-4 mx-auto'>
          <div className='img-div'>
        <img src={image2} className={`web-imgs-2  ${animateClassRight}`} ref={ref}/>

          </div>
        </div>
       
      </div>
    </div>
      </section>

      <section id="benefits" className={`benefits-section`}>
      <div className="container">
      <div className="row">
      <div className='col-lg-4 mx-auto'>
          <div className='img-div'>
        <img src={image4} className={`web-imgs-3 ${animateClassLeft}`} ref={ref}/>

          </div>
        </div>
        <div className="col-lg-8 mx-auto">
          <h2 className="section-heading text-center benefit-heading header-title">Benefits of EngageTalent.AI</h2>
          <hr className="my-4 benefit-hr" />
          <div className={`benefit-description-container  ${animateClassLeft}`} ref={ref}>
            <div className="benefit-description">
              <h3 className="benefit-title sub-header-title">Significant Time Savings</h3>
              <p className="benefit-text">
                EngageTalent.AI dramatically reduces the time-to-hire by swiftly evaluating and grading candidates without compromising on the quality of assessment. Recruiters can process a higher volume of candidates in a fraction of the time it takes through traditional methods. This rapid turnaround is invaluable in a competitive job market where the ability to quickly secure top talent can be the differentiator between success and lost opportunity.
              </p>
            </div>

            <div className="benefit-description">
              <h3 className="benefit-title sub-header-title">Enhanced Hiring Quality</h3>
              <p className="benefit-text">
                Our AI-driven platform ensures that the candidates you engage with are of the highest caliber. By leveraging advanced algorithms and data analytics, EngageTalent.AI provides a robust screening process that identifies candidates with the optimal mix of skills and potential, leading to better hiring decisions and a stronger team composition, which is crucial for driving organizational success.
              </p>
            </div>

            <div className="benefit-description">
              <h3 className="benefit-title sub-header-title">Cost Reduction</h3>
              <p className="benefit-text">
                By automating the initial stages of the recruitment process, EngageTalent.AI cuts down on the substantial costs associated with traditional recruitment methods. The need for extensive recruiter hours is minimized, reducing labor costs and allowing your human resources to focus on strategic decision-making. Additionally, by improving the quality of hires, EngageTalent.AI reduces the long-term costs of turnover and retraining.
              </p>
            </div>

            <div className="benefit-description">
              <h3 className="benefit-title sub-header-title">Transparent Decision-Making</h3>
              <p className="benefit-text">
                The detailed reports generated by EngageTalent.AI offer clear, data-driven insights into each candidate's abilities. This transparency ensures that hiring managers are fully informed about the competencies of potential hires, facilitating a more effective selection process. As a result, decisions are made with confidence, and the potential for human bias is significantly reduced.
              </p>
              {/* <center><button className="button-demo">Demo</button></center> */}
            </div>
          </div>
        </div>
   
 
      </div>
    </div>
      </section>

      <section id="testimonials" className={`testimonials-section`} >
        <div className="container">
      <div className="row">
        <div className="col-lg-10 mx-auto">
          <h2 className="section-heading text-center testimonials-heading header-title">Our Clients</h2>
          <hr className="my-4 testimonials-hr" />
          {/* <div className={`testimonial-item testimonials-item  ${animateClassRight}`} ref={ref}>
            <blockquote className="blockquote text-center">
              <p className="mb-4 testimonials-text">
                "EngageTalent.AI has transformed our recruitment process. The accuracy and depth of the AI assessments allow us to confidently make hiring decisions, saving us countless hours and resources. The platform is intuitive and the support from DataLake Solutions LLC is unparalleled. Highly recommended for any recruiting firm looking to innovate."
              </p>
              <footer className="blockquote-footer testimonials-footer" style={{color:'white'}}><cite title="Company Name">Stratosphere IT Services Pvt. Ltd.</cite></footer>
            </blockquote>
          </div>
          <div className={`testimonial-item testimonials-item  ${animateClassLeft}`} ref={ref}>
            <blockquote className="blockquote text-center">
              <p className="mb-4 testimonials-text">
                "The level of detail in the summary reports provided by EngageTalent.AI is exceptional. It’s clear, concise, and cuts down our hiring time by more than half. This AI tool is a game-changer for our recruitment strategy, especially in the competitive tech industry."
              </p>
              <footer className="blockquote-footer testimonials-footer" style={{color:'white'}}><cite title="Company Name">KK Software Associates (Global) Pvt Ltd</cite></footer>
            </blockquote>
          </div>
          <div className={`testimonial-item testimonials-item  ${animateClassRight}`} ref={ref}>
            <blockquote className="blockquote text-center">
              <p className="mb-4 testimonials-text">
                "As a hiring manager, EngageTalent.AI has been a revelation. The platform’s ability to evaluate technical skills accurately has helped us hire top-tier candidates with confidence. The cost-saving aspect is just the cherry on top. I can’t imagine going back to the old ways of recruiting."
              </p>
              <footer className="blockquote-footer testimonials-footer" style={{color:'white'}}>Sarah Johnson, <cite title="Company Name">Appdecs Technologies Pvt Ltd</cite></footer>
            </blockquote>
          </div> */}
          <div className='container'>
          <div className='row'>
            <div className='col-md-4'>
            <div className='img-div'>
              <img src={image6} className={`company-imgs ${animateClassLeft}`} ref={ref} style={{width:'35%'}}/>
              </div>
              <p className='company-name-sty'>Data Lake Solutions</p>
              

            </div>
            <div className='col-md-4'>
            <div className='img-div'>
        <img src={image9} className={`company-imgs ${animateClassRight}`} ref={ref} style={{width:'28%'}}/>

          </div>
          <p className='company-name-sty'>Stratosphere IT Services</p>

            </div>
            <div className='col-md-4'>
            <div className='img-div'>
        <img src={image7} className={`company-imgs ${animateClassLeft}`} ref={ref} />

          </div>
          <p className='company-name-sty'>United Software Group</p>

            </div>

          </div>
          <div className='row' style={{paddingTop:'70px'}}>
            <div className='col-md-4'>
            <div className='img-div'>
              <img src={image8} className={`company-imgs ${animateClassLeft}`} ref={ref} />
              </div>
              <p className='company-name-sty'>Appdecs Technologies</p>
              

            </div>
            <div className='col-md-4'>
            <div className='img-div'>
        <img src={image10} className={`company-imgs ${animateClassRight}`} ref={ref}/>

          </div>
          <p className='company-name-sty'>KK Software Associates</p>

            </div>
            <div className='col-md-4'>
            <div className='img-div'>
        <img src={image11} className={`company-imgs ${animateClassRight}`} ref={ref}/>

          </div>
          <p className='company-name-sty'>Your BUDDY</p>

            </div>

          </div>
          </div>
       
          
        </div>
      </div>
    </div>
      </section>

      <section id="contact" className={`contact-section`} >
      <div className="container">
      <div className="">
        <div className="col-lg-8 mx-auto text-center">
          <h2 className="section-heading header-title">Get In Touch and Demo</h2>
          <hr className="my-4" />
        </div>
        <div className="container">
        <div className='row'>
            <div className='col-md-6'>
            <div className={`contact-form ${animateClassRight}`}>
              <form onSubmit={handleSubmit}>
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Your name.."
                  value={formData.name}
                  onChange={handleChange}
                  required
                />

                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Your email.."
                  value={formData.email}
                  onChange={handleChange}
                  required
                />

                <label htmlFor="subject">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  placeholder="Subject.."
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />

                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  placeholder="Write something.."
                  style={{ height: '200px' }}
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
                {success && <p style={{color:'green',fontWeight:600,textAlign:'center'}}>{success}</p>}

                <button type="submit">Submit</button>
              </form>
            </div>
            </div>
            <div className='col-md-6'>
              <div className='img-div'>
            <img src={image5} className={`web-imgs-2 ${animateClassLeft}`} ref={ref}/>

              </div>
            </div>
          </div>
        </div>

        <p className="mb-4 text-center">We're here to help and answer any questions you might have. We look forward to hearing from you.</p>
        <div className="container">
          
        </div>
        <div className='row'>
          <div className='col-md-6 contact-box-shadow'>
          <div className="col-lg-8 mx-auto text-center">
          <p className='contact-title-sty'>USA</p>
        <div className="contact-detail">
        <span className="contact-icon" style={contactDetailStyle}>
          <i className="fas fa-map-marker-alt"></i>
        </span>
        <p className="contact-info" style={contactInfoStyle}>
          8837 Whitney Dr
        </p>
        <p className="contact-info" style={contactInfoStyle}> 
          Lewis Center, OH 43035
        </p>
      </div>
      <div className="contact-detail">
        <span className="contact-icon" style={contactDetailStyle}>
          <i className="fas fa-phone"></i>
        </span>
        <p className="contact-info" style={contactInfoStyle}>
          (+1) 614 218 8735
        </p>
      </div>
      <div className="contact-detail">
        <span className="contact-icon" style={contactDetailStyle}>
          <i className="fas fa-envelope"></i>
        </span>
        <p className="contact-info" style={contactInfoStyle}>
          <a href="mailto:info@datalake-solutions.com" style={{ color: '#2b7a78', textDecoration: 'none' }}>
            info@datalake-solutions.com
          </a>
        </p>
      </div>
        </div>
          </div>
          <div className='col-md-6 contact-box-shadow'>
          <div className="col-lg-8 mx-auto text-center">
            <p className='contact-title-sty'>INDIA</p>
        <div className="contact-detail">
        <span className="contact-icon" style={contactDetailStyle}>
          <i className="fas fa-map-marker-alt"></i>
        </span>
        <p className="contact-info" style={contactInfoStyle}>
        2nd Floor, JQ Chambers Jayabheri Enclave, Gachibowli Hyderabad, Telangana 500032
        </p>
      </div>
      <div className="contact-detail">
        <span className="contact-icon" style={contactDetailStyle}>
          <i className="fas fa-phone"></i>
        </span>
        <p className="contact-info" style={contactInfoStyle}>
        (+91) 7032442682
        </p>
      </div>
      <div className="contact-detail">
        <span className="contact-icon" style={contactDetailStyle}>
          <i className="fas fa-envelope"></i>
        </span>
        <p className="contact-info" style={contactInfoStyle}>
          <a href="mailto:info@datalake-solutions.com" style={{ color: '#2b7a78', textDecoration: 'none' }}>
            info@datalake-solutions.com
          </a>
        </p>
      </div>
        </div>
          </div>
        </div>
     
      
      </div>
    </div>
      </section>

      <footer>
      <p style={{color:'white'}}>&copy; 2024 Data Lake Solutions LLC. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default HomePage;
